/**
 * Calcula os pontos diários baseado nas metas concluídas
 * Regras:
 * - treino concluído: +20
 * - sono concluído: +20 (sleep_hours >= 7)
 * - refeições concluídas: +20 (meals_logged >= 6)
 * Total diário máximo: 60 pontos
 */
export interface DailyProgressData {
  workout_completed: boolean;
  sleep_hours: number | null;
  meals_logged: number;
}

export function calculateDailyPoints(data: DailyProgressData): number {
  let points = 0;

  // Treino concluído: +20
  if (data.workout_completed) {
    points += 20;
  }

  // Sono concluído: +20 (se >= 7 horas)
  if (data.sleep_hours !== null && data.sleep_hours >= 7) {
    points += 20;
  }

  // Refeições concluídas: +20 (se >= 6 refeições)
  if (data.meals_logged >= 6) {
    points += 20;
  }

  // Limitar a 60 pontos por dia
  return Math.min(points, 60);
}

/**
 * Determina se as refeições foram concluídas (>= 6 refeições)
 */
export function isMealsCompleted(meals_logged: number): boolean {
  return meals_logged >= 6;
}

/**
 * Determina se o sono foi concluído (>= 7 horas)
 */
export function isSleepCompleted(sleep_hours: number | null): boolean {
  return sleep_hours !== null && sleep_hours >= 7;
}

